module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/octopus-english.b555d559.jpg";